'use client'

import dynamic from 'next/dynamic'
import { usePathname } from 'next/navigation'
import { GATrackingProvider } from './ga-tracking-provider'

const Footer = dynamic(() =>
  import('@/components/layout/footer').then((mod) => mod.Footer)
)
const Header = dynamic(() =>
  import('@/components/layout/header').then((mod) => mod.Header)
)
const BackToTop = dynamic(() =>
  import('@/components/ui/back-to-top').then((mod) => mod.BackToTop)
)
const ContactFab = dynamic(() =>
  import('@/components/ui/contact-fab').then((mod) => mod.ContactFab)
)

const StickySetting = dynamic(
  () =>
    import('@/components/layout/sticky-setting').then(
      (mod) => mod.StickySetting
    ),
  {
    ssr: false,
  }
)

const StickyCoolClub = dynamic(
  () =>
    import('@/components/layout/sticky-coolclub').then(
      (mod) => mod.StickyCoolClub
    ),
  {
    ssr: false,
  }
)

const pathsWithNoLayout = ['/wireframe']

const pathsWithNoFooter = ['/checkout', '/cart']

const pathsWithNoSticky = ['/cart']

const pathsWithNoTopBar = ['/cart']

const pathsWithNoNavbar = ['']

const pathsWithNoPromotion = ['/cart']

const pathsWithNoGATracking = ['/auth/callback']

export const LayoutProvider = ({
  children,
  isMobile,
}: {
  children: React.ReactNode
  isMobile: boolean
}) => {
  const pathname = usePathname()

  const shouldShowLayout = !pathsWithNoLayout.includes(pathname)
  const shouldShowFooter = !pathsWithNoFooter.includes(pathname)
  const shouldShowSticky = !pathsWithNoSticky.includes(pathname)

  const shouldShowTopBar = !pathsWithNoTopBar.includes(pathname)
  const shouldShowNavbar = !pathsWithNoNavbar.includes(pathname)
  const shouldShowPromotion = !pathsWithNoPromotion.includes(pathname)

  const shouldShowGATracking = !pathsWithNoGATracking.includes(pathname)

  if (!shouldShowLayout) {
    return <>{children}</>
  }

  return (
    <GATrackingProvider shouldShowGATracking={shouldShowGATracking}>
      <Header
        isShowTopBar={shouldShowTopBar}
        isShowNavbar={shouldShowNavbar}
        isShowPromotion={shouldShowPromotion}
        isMobile={isMobile}
      />
      <main className='min-h-screen'>{children}</main>
      {shouldShowFooter && <Footer />}
      {shouldShowSticky && <BackToTop />}
      {shouldShowSticky && <ContactFab />}

      <StickySetting />
      <StickyCoolClub />
    </GATrackingProvider>
  )
}
